import { z } from 'zod';
/** Ziel eines call:*-Events (Socket-ID der Gegenseite). */
export const callTargetSchema = z.object({
    to: z.string().min(1).max(64),
});
/** Quittung eines verpassten Anklingelversuchs (Benutzer-ID des Anrufers). */
export const missedRingAckSchema = z.object({
    fromUserId: z.string().min(1).max(64),
});
export const settingsUpdateSchema = z
    .object({
    ringRequired: z.boolean().optional(),
    noiseSuppression: z.boolean().optional(),
    echoCancellation: z.boolean().optional(),
    autoGainControl: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).length > 0, 'Mindestens ein Feld erforderlich');
//# sourceMappingURL=callSchema.js.map